import { useQuery } from '@tanstack/react-query';
import { fetchOnuHistory } from '../lib/api.js';

// Timeline de transições — não precisa refresh agressivo (só muda quando ONU muda status).
export function useOnuHistory(sn, { days = 15, enabled = true } = {}) {
  return useQuery({
    queryKey: ['v2', 'onu-history', sn, { days }],
    queryFn: () => fetchOnuHistory(sn, days).then((r) => r.data),
    enabled: Boolean(sn) && enabled,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
